import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["name", "id", "placeholder", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback",
  role: "alert"
}

import { ref, toRef, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false,
},
  __name: 'FileInput',
  props: {
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [File, String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
        required: false,
    },
    error: {
        type: String,
        default: null,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {


const props = __props;

const fileValue = ref("");

const emit = __emit;

const name = toRef(props, "name");
const file = ref<File | null>();
const handleFileUpload = (event) => {
    fileValue.value = event.target.files[0].name;
    emit("update:modelValue", event.target.files[0]);
};

watch(
    () => props.modelValue,
    (newValue, oldValue) => {
        if (newValue == "" || newValue == null) {
            (file.value as any).value = null;
        }
    },
    { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      name: name.value,
      ref_key: "file",
      ref: file,
      id: name.value,
      type: "file",
      class: _normalizeClass(["form-control rounded", { 'is-invalid': !!__props.error}]),
      placeholder: _ctx.placeholder,
      disabled: __props.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (handleFileUpload( $event )))
    }, null, 42, _hoisted_1),
    (__props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})